import React from 'react';
import AppLink from '../links/AppLink';
import PropTypes from 'prop-types';
import css from './SearchError.module.less';
import { Button } from 'edcom-ui';

const SearchError = ({ href }) => {
  const offline =
    typeof window !== 'undefined' && window.navigator.onLine === false;

  const message = offline
    ? 'Please check your internet connection and try again.'
    : 'There was an error searching. Please try again.';

  return (
    <div className={css.container}>
      <p className={css.error}>{message}</p>
      <AppLink href={href}>
        <Button color="primary">Try Again</Button>
      </AppLink>
    </div>
  );
};

SearchError.propTypes = {
  href: PropTypes.string.isRequired,
};

export default SearchError;
